window.Settings = {
    // determine open in rdk option
    open_in_rdk: false,
    
    // determine 3d view option (open in robodk web)
    // true -> don't include 3d view
    // false -> include 3d view
    on_robodk_web: false,

    LOCAL_BUILD: window.location.href.includes("localhost"),
}